import { Injectable } from '@angular/core';
import { ApiService,UserService } from '../..';
@Injectable()
export class DiemDoKhaiBaoSaiService {

  constructor(private api: ApiService, private userService: UserService) { }
  APIURL = "api/ExcuteOracle";
  getDanhSachSaiThongTin(danhmucid, sotrang, sodong) {
    let curUs = this.userService.getCurrentUser();
    var param = {
      config: JSON.stringify({ namesql: "PKG_KHAIBAOKHACHHANG.P_LAYDS_KHACHHANG_KHAIBAOSAI" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_sotrang: sotrang,
        v_sodong: sodong,
        v_mataikhoan: curUs.mataikhoan,
        v_ip: ""
      })
    };
    return this.api.Excute(this.APIURL, param);
  }

  exportExcelDanhSachSaiThongTin(danhmucid, tendonvi, tenchucnang, noidungbaocao) {
    let cols = [
      { "name": "stt", "label": "STT", "horizontalalignment": "center" },
      { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
      { "name": "meterid", "label": "Meterid", "horizontalalignment": "left" },
      { "name": "imei", "label": "IMEI", "horizontalalignment": "left" },
      { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
      { "name": "tenkhachhang", "label": "Tên điểm đo", "horizontalalignment": "left" },
      { "name": "ngaylap", "label": "Ngày lắp", "horizontalalignment": "center" },
      { "name": "songayqua", "label": "Số ngày khai báo sai", "horizontalalignment": "right" },
      { "name": "diachi", "label": "Vị trí điểm đo", "horizontalalignment": "left" },
      { "name": "thongbao", "label": "Ghi chú", "horizontalalignment": "left" },
    ];
    let curUs = this.userService.getCurrentUser();
    let para: any = JSON.stringify({
      v_danhmucid: danhmucid,
      v_sotrang: 0,
      v_sodong: 1000000,
      v_mataikhoan: curUs.mataikhoan,
      v_ip: ""
    });
    let config = JSON.stringify({ namesql: "PKG_KHAIBAOKHACHHANG.P_LAYDS_KHACHHANG_KHAIBAOSAI" });
    return this.api.exportExcel("", cols, para, config, tendonvi, tenchucnang, noidungbaocao);
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/nhap-thong-tin-kh/diem-do-khai-bao-sai/diemdokhaibaosai.service.ts